import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { ReturnInvoiceRequest, ReturnInvoiceRequestsListViewModel, ReturnInvoiceRequestStateEnumProvider } from "./returnInvoiceRequestsList-viewModel"

export class ReturnInvoiceRequestsListView extends View<ReturnInvoiceRequestsListViewModel>{
    GetViewUniqueId(): string {
        return "V-EC63701D-BCB3-4C2B-B02C-BBB9C3094BC0"
    }
    loadHtml(): string {
        let element = require('./returnInvoiceRequestsList.html').default;
        let style = require('./returnInvoiceRequestsList.less');
        return element;
    }
    constructor() {
       super();
    }
    public set requestStateEnumProvider(v: ReturnInvoiceRequestStateEnumProvider) { this._requestStateEnumProvider = v; } public get requestStateEnumProvider(): ReturnInvoiceRequestStateEnumProvider { return this._requestStateEnumProvider;} private _requestStateEnumProvider: ReturnInvoiceRequestStateEnumProvider;
    public set returnInvoiceRequests(v: ObservableArray<ReturnInvoiceRequest>) { this._returnInvoiceRequests = v; } public get returnInvoiceRequests(): ObservableArray<ReturnInvoiceRequest> { return this._returnInvoiceRequests;} private _returnInvoiceRequests: ObservableArray<ReturnInvoiceRequest>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

}
